import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ITourType } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./TourType";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: ITourType[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("tourtype", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { tourType: ITourType[], count: number } = await response.json();
            setTableData({ data: data.tourType, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };

    const openEdit = (rowDatauser: ITourType) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const Remove = async (rowData: ITourType) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`tourtype/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "TourType Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: ITourType) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("TourType", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Tour Type</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("TourType", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );


    const actionBodyTemplate = (rowData: ITourType) => {
        return (
            <div className="actions">
                {props.hasPermission("TourType", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("TourType", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>}
            </div>
        );
    };

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="name" header="Tour Type" sortable />
                <Column field="desc" header="Desc" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}
